import { NotificationTypes } from '@griply/types';

const notificationToNotificationTrackingTypeMap: Record<
  string,
  NotificationTypes
> = {
  taskReminder: NotificationTypes.TaskReminder,
  dailyReflection: NotificationTypes.DailyReflection,
  weeklyReflection: NotificationTypes.WeeklyReflection,
  externalCalendarEvent: NotificationTypes.ExternalCalendarEvent,
};

export const notificationsToTrackingNotificationType = (
  notificationKey: string,
) => notificationToNotificationTrackingTypeMap[notificationKey];
